<template>
    <div :class="getStatusHeader.header.minimaze ? 'card-with-chart-op' : 'card-with-chart-op-minimaze'">
        <div class="card-top">
            <div class="card-with-chart__title">
                <div class="card-with-chart__title_text">
                    {{nameCurrency}}{{name}}
                    <span>{{countPositions}} </span>
                </div>
                <div class="card-with-chart__title_text-percent" v-if="statistic.Summary.ProfitableDeals">
                    {{profitableDeals}}%
                </div>
            </div>
            <div class="card-with-chart__data-balance">
                    <watcher
						:data="statistic.DailyRecords[this.statistic.DailyRecords.length - 1].EquityClose"
						:units="'$'"
                        >
					</watcher>
            </div>
            <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
                <div v-show="getStatusHeader.header.minimaze" class="card-with-chart__data-percent">
                    <watcher :data="deltaEquity"
							 :units="'%'"
                        >

					</watcher>
                </div>
            </transition>
        </div>
        <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
            <div  v-show="getStatusHeader.header.minimaze" class="card-with-chart__data-maxdd">
                MAX. DD {{drawdown}}%
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Watcher from '../ui-components/ui-data-watcher'
export default {
    components: {
        'watcher':Watcher
    },
  props: {
    symbol:{ default: '' },
    nameCurrency: { default: "" },
    name:{default:''},
    widthWidget: {default:'156px'},
  },
  data() {
    return {
        statistic:{
            Summary: {
                ProfitableDeals:0
            },
            DailyRecords : [
                {
                    EquityOpen:0,
                    EquityClose:0
                }
            ]
        }
    };
  },
  computed: {
    ...mapGetters({
              getStatistics: 'accountstat/getCroppedStatBySymbol',
              getStatusHeader: 'usersets/getSettings'
        }),
    statOpenPositions() {
      return this.$store.getters["positions/getPositionsBySymbol"](this.nameCurrency);
    },
    deltaEquity() {
       return (this.statistic.Summary.Equity - this.statistic.DailyRecords[0].EquityOpen) / this.statistic.Summary.Equity*100;
    },
    profitableDeals() {
        if(!this.statistic.Summary.ProfitableDeals) return 0;
        return (this.statistic.Summary.ProfitableDeals / (this.statistic.Summary.TotalDeals / 100)).toFixed();
    },
    countPositions(){
         if (!this.statOpenPositions || !this.statOpenPositions.length) return 0;
         return this.statOpenPositions.length;
    },
    drawdown() {
        if(!this.statistic.Summary.Drawdown1000) return 0;
        return this.statistic.Summary.Drawdown1000.toFixed(2);
    }
  },
  methods: {
      updateStatistics(symbol)
      {
          if (!symbol) symbol = this.symbol;
            let stat = this.getStatistics(symbol);
            if (!stat) {
                return;
            }
            this.statistic = stat;
      }
  },
  created() {
        subscribeOnUpdate(this.$store, this.symbol, isFirstObtained => {

                this.updateStatistics(this.symbol)

        });
        this.updateStatistics(this.symbol)
    }
};

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: `header-chart-${symbol}`,
            handler: handler
        }
    });
}
</script>
<style lang="less" scoped>
@keyframes change-padding {
    from {
        padding: 8px 12px 12px 12px;
    }
    to {
        padding: 4px 12px 12px 12px;
    }
}
@keyframes change-padding-full {
    from {
        padding: 4px 12px 12px 12px;
    }
    to {
        padding: 8px 12px 12px 12px;
    }
}
.card-with-chart-op {
    animation: change-padding-full 0.6s ease-in 1;
    display: flex;
    flex-direction: column;
    background: #3d536b;
    margin-right: 1px;
    padding: 8px 12px 12px 12px;
    flex-grow: 1;
    min-height: 100%;
    width: 150px;
    &-minimaze {
        animation: change-padding 0.6s ease-in 1;
        display: flex;
        flex-direction: column;
        background: #3d536b;
        margin-right: 1px;
        padding: 4px 12px 12px 12px;
        flex-grow: 1;
        min-height: 100%;
        width: 150px;
        justify-content: space-between;
    }
}

.card-with-chart__title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.card-with-chart__data {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  min-height: fit-content;
}

.card-with-chart__title_text {
  font-family: Arimo;
  font-size: 10px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: 0.4px;
  color: #ffffff;
  max-height: 16px;
  text-transform: uppercase;
}

.card-with-chart__title_text span {
  color: #aabed2;
}

.card-with-chart__title_text-percent {
  font-family: Arimo;
  font-size: 13px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.23;
  letter-spacing: 0.4px;
  color: #00ffd0;
}

.card-with-chart__data {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card-with-chart__data-balance {
  font-family: Arimo;
  font-size: 16px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #00ffd0;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
}

.card-with-chart__data-percent {
  font-family: Arimo;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #0fd7b7;
}

.card-with-chart__data-maxdd {
  font-family: Arimo;
  font-size: 10px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: 0.4px;
  color: @colors[red];
  margin-top:4px;
}
</style>
